export enum AuthenticationRoutes {
  Login = 'login',
  Logout = 'logout',
  ConfirmLogin = 'confirm-login',
  ConfirmLogout = 'confirm-logout',
}
